export default function responsiveVideo(mqlMatches) {
  const targets = document.querySelectorAll(".js-responsiveVid");
  if (targets.length == 0) return; //対象の要素がなければ、処理終了

  //処理開始
  targets.forEach((video) => {
    let source = video.querySelector("source");
    let [srcPc, srcSp] = [source.getAttribute("src"), source.getAttribute("data-vid")];

    if (mqlMatches) {
      source.src = srcSp;
      source.dataset.vid = srcPc;
      video.load();
      video.play();
    } else {
      [srcPc, srcSp] = [srcSp, srcPc];
      source.src = srcPc;
      source.dataset.vid = srcSp;
      video.load();
      video.play();
    }
  });
}
